import React from 'react';
import { useField, useFormikContext } from 'formik';
import { VendorContactGroupRelationship } from '../../../models/VendorContactGroupRelationship';
import { useAppSelector } from '../../../utils/Hooks';

interface HitsTableProps {
    name: string;
    label: string;
}

const HitsTable: React.FC<HitsTableProps> = ({ name, label }) => {
    const { setFieldValue } = useFormikContext<VendorContactGroupRelationship[]>();
    const [field] = useField<VendorContactGroupRelationship[]>(name);
    const countriesState = useAppSelector((state) => state.countries);
    const servicesState = useAppSelector((state) => state.services);

    const serviceOptions = servicesState.services.map((service) => ({
        value: service.id.toString(),
        label: service.name,
    }));

    const handleAddElement = () => {
        const newArray = field?.value ? [...field.value] : [];
        newArray.push({
            id: newArray.length + 1,
            country1_id: 0,
            country2_id: 0,
            client_contact_id: 0,
            partial: 0,
            full: 0,
            service_id: 16
            //service_id: serviceOptions.length > 0 ? parseInt(serviceOptions[0].value) : 0
        });
        setFieldValue(field.name, newArray);
    };

    const handleChange = (index: number, fieldKey: string, value: any) => {
        const newArray = field.value.map((item, i) => {
            if (i === index) {
                return {
                    ...item,
                    [fieldKey]: value
                };
            }
            return item;
        });
        setFieldValue(field.name, newArray);
    };

    const handleRemoveRow = (index: number) => {
        const newArray = [...field.value];
        newArray.splice(index, 1);
        setFieldValue(field.name, newArray);
    };

    return (
        <div className="form" style={{ padding: '10px' }}>
            <h2 style={{ padding: '10px' }}>
                <span>{label}</span>
            </h2>
            {Array.isArray(field.value) && field.value.length > 0 && (
                <table style={{ padding: '10px' }}>
                    <thead>
                    <tr>
                        <th style={{ padding: '10px' }}>Kust</th>
                        <th style={{ padding: '10px' }}>Kuhu</th>
                        <th style={{ padding: '10px' }}>0.1 - 13.5 ldm</th>
                        <th style={{ padding: '10px' }}>13.6 ldm</th>
                        <th style={{ padding: '10px' }}>Teenus</th>
                        <th style={{ padding: '10px' }}></th>
                    </tr>
                    </thead>
                    <tbody>
                    {field.value.map((item, index) => (
                        <tr key={index} style={{ padding: '10px' }}>
                            <td>
                                <select
                                    value={item.country1_id}
                                    onChange={(e) => handleChange(index, 'country1_id', parseInt(e.target.value))}
                                >
                                    <option value="">Vali riik</option>
                                    {countriesState.countries.map((country) => (
                                        <option key={country.id} value={country.id}>
                                            {country.name}
                                        </option>
                                    ))}
                                </select>
                            </td>
                            <td>
                                <select
                                    value={item.country2_id}
                                    onChange={(e) => handleChange(index, 'country2_id', parseInt(e.target.value))}
                                >
                                    <option value="">Vali riik</option>
                                    {countriesState.countries.map((country) => (
                                        <option key={country.id} value={country.id}>
                                            {country.name}
                                        </option>
                                    ))}
                                </select>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <input
                                    type="checkbox"
                                    checked={item.partial === 1}
                                    onChange={(e) => handleChange(index, 'partial', e.target.checked ? 1 : 0)}
                                />
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <input
                                    type="checkbox"
                                    checked={item.full === 1}
                                    onChange={(e) => handleChange(index, 'full', e.target.checked ? 1 : 0)}
                                />
                            </td>
                            <td>
                                <select
                                    value={item.service_id ?? ''}
                                    onChange={(e) => handleChange(index, 'service_id', parseInt(e.target.value))}
                                >
                                    <option value="">Vali teenus</option>
                                    {serviceOptions.map((service) => (
                                        <option key={service.value} value={service.value}>
                                            {service.label}
                                        </option>
                                    ))}
                                </select>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                    <span style={{ color: 'red', cursor: 'pointer' }} onClick={() => handleRemoveRow(index)}>
                                        X
                                    </span>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            )}
            <button type="button" onClick={handleAddElement} style={{ padding: '10px', marginBottom: '10px' }}>
                <span>
                    <strong>Lisa</strong>
                </span>
            </button>
        </div>
    );
};

export default HitsTable;